import React, { createContext, useEffect, useReducer, useState } from 'react';

import MatxLoading from "../../components/MatxLoading";
import SessionOut from "../../views/sessions/SessionOut";
import useError from "../../hooks/useError";
import axios from './../../../axios';

const initialValue = {
    sub_categories: []
};
const reducer = (state, action) => {
    switch (action.type) {
        case 'LOAD_DASHBOARD_DATA': {
            return {
                ...state,
                sub_category_list: action.payload,
            }
        }

        case 'UNAUTHORIZED': {
            return {
                ...state,
                status: 401,
            }
        }
        default: {
            return state
        }
    }
}

const SubCategoryContext = createContext({
    sub_category_list: initialValue,
    getSubCategories: () => { },
    addSubCategory: () => { },
    updateSubCategory: () => { },
    uploadImage: () => { },
    getSubCategoryById: () => { },
    changeProductDelivery: () => { },
    getChildSubCategories: () => { },
})

export const SubCategoryProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialValue);
    const { setError } = useError()


    const changeProductDelivery = async (sub_category_id, status) => {

        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers: {
                    'Authorization': 'Bearer ' + accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get(`/api/products/change_product_delivery_by_sub_category/${sub_category_id}/${status}`, options);

            return res;
        } catch (e) {
            if (e?.response?.status === 401) {
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            } else if (e?.response?.status === 400) {
                setError({ title: "Error", message: e.response?.data?.message ?? "Something wrong on server", status: 400 })

            } else if (e?.response?.status === 500) {
                setError({ title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400 })
            } else {
                setError({ title: "Network Error", message: "Network error occurred", status: 400 })
            }
            return e;
        }
    }

    const getSubCategories = async () => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers: {
                    'Authorization': 'Bearer ' + accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get('/api/categories/get_sub_categories', options);

            dispatch({
                type: 'LOAD_DASHBOARD_DATA',
                payload: res.data,
            })
        } catch (e) {
            if (e.response.status === 401) {
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            } else if (e.response.status === 400) {
                setError({ title: "Error", message: e.response?.data?.message ?? "Something wrong on server", status: 400 })

            } else if (e.response.status === 500) {
                setError({ title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400 })
            } else {
                setError({ title: "Network Error", message: "Network error occurred", status: 400 })
            }
        }
    }


    const uploadImage = async (data) => {
        try {
            const options = {
                headers: { 'Content-Type': 'multipart/form-data' }
            }

            const res = await axios.post('/api/upload_product_image', data, options);

            return res.data;
        } catch (e) {
            if (e.response.status === 401) {
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            } else if (e.response.status === 400) {
                setError({ title: "Error", message: e.response?.data?.message ?? "Something wrong on server", status: 400 })

            } else if (e.response.status === 500) {
                setError({ title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400 })
            } else {
                setError({ title: "Network Error", message: "Network error occurred", status: 400 })
            }
            return null;
        }
    }

    const getSubCategoryById = async (id) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers: {
                    'Authorization': 'Bearer ' + accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }
            const res = await axios.get('/api/categories/get_sub_category/' + id, options);

            return res.data;
        } catch (e) {
            if (e.response.status === 401) {
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            } else if (e.response.status === 400) {
                setError({ title: "Error", message: e.response?.data?.message ?? "Something wrong on server", status: 400 })

            } else if (e.response.status === 500) {
                setError({ title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400 })
            } else {
                setError({ title: "Network Error", message: "Network error occurred", status: 400 })
            }
            return null;
        }
    }

    const getChildSubCategories = async (parent_id) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers: {
                    'Authorization': 'Bearer ' + accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }
            const res = await axios.get(`/api/categories/get_child_sub_categories/${parent_id}`, options);

            return res.data;
        } catch (e) {
            if (e?.response?.status === 401) {
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            } else if (e?.response?.status === 400) {
                setError({ title: "Error", message: e.response?.data?.message ?? "Something wrong on server", status: 400 })
            } else if (e?.response?.status === 500) {
                setError({ title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400 })
            } else {
                setError({ title: "Network Error", message: "Network error occurred", status: 400 })
            }
            return null;
        }
    }

    const addSubCategory = async (data) => {
        const accessToken = window.localStorage.getItem('accessToken');
        try {
            const options = {
                headers: {
                    'Authorization': 'Bearer ' + accessToken,
                    'Content-Type': 'application/json',
                }
            }
            return await axios.post('/api/categories/add_sub_category', data, options);
        } catch (e) {
            if (e?.response?.status === 401) {
                dispatch({
                    type: 'UNAUTHORIZED',
                });
            } else if (e?.response?.status === 400) {
                setError({ title: "Error", message: e.response?.data?.message ?? "Something wrong on server", status: 400 });
            } else if (e?.response?.status === 500) {
                setError({ title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400 });
            } else {
                setError({ title: "Network Error", message: "Network error occurred", status: 400 });
            }
            return e;
        }
    }

    const updateSubCategory = async (data) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers: {
                    'Authorization': 'Bearer ' + accessToken,
                    'Content-Type': 'application/json',
                }
            }
            return await axios.post('/api/categories/update_sub_category', data, options);
        } catch (e) {
            if (e?.response?.status === 401) {
                dispatch({
                    type: 'UNAUTHORIZED',
                })
            } else if (e?.response?.status === 400) {
                setError({ title: "Error", message: e.response?.data?.message ?? "Something wrong on server", status: 400 })

            } else if (e?.response?.status === 500) {
                setError({ title: "Server Error", message: "Server error occurred. please try again after sometime", status: 400 })
            } else {
                setError({ title: "Network Error", message: "Network error occurred", status: 400 })
            }
            return e;
        }
    }

    useEffect(() => {
        getSubCategories();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])



    if (state.status === 401) {
        return <SessionOut />
    }

    if (state.sub_category_list === undefined) {
        return <MatxLoading />
    }

    return (
        <SubCategoryContext.Provider
            value={{
                sub_category_list: state.sub_category_list,
                getSubCategories,
                addSubCategory,
                updateSubCategory,
                uploadImage,
                getSubCategoryById,
                changeProductDelivery,
                getChildSubCategories,
            }}
        >
            {children}
        </SubCategoryContext.Provider>
    )
}

export default SubCategoryContext
